var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('d-body-top-bar',{attrs:{"title":_vm.$t('views.shop.title'),"full-body":false}}),_c('product-stock')],1)}
var staticRenderFns = []

export { render, staticRenderFns }